export const WEBAPP_URL = process.env.REACT_APP_WEBAPP_URL!;
export const API_URL = process.env.REACT_APP_API_URL!;
export const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT!;
export const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY!;
export const NODE_ENV = process.env.NODE_ENV!;



// WEBPACK FOOTER //
// ./src/config/environment.ts